/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ConvexStakingWrapper,
  ConvexStakingWrapperInterface,
} from "../ConvexStakingWrapper";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "_wrapped",
        type: "bool",
      },
    ],
    name: "Deposited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_hook",
        type: "address",
      },
    ],
    name: "HookSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "RewardAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_rewardToken",
        type: "address",
      },
    ],
    name: "RewardInvalidated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "Shutdown",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_userA",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "_userB",
        type: "address",
      },
    ],
    name: "UserCheckpoint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "_unwrapped",
        type: "bool",
      },
    ],
    name: "Withdrawn",
    type: "event",
  },
  {
    inputs: [],
    name: "addRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "addTokenReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "collateralVault",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "convexBooster",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "convexPool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "convexPoolId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "convexToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "crv",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "curveToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "cvx",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "earned",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct ConvexStakingWrapper.EarnedData[]",
        name: "claimable",
        type: "tuple[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "earnedView",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct ConvexStakingWrapper.EarnedData[]",
        name: "claimable",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "address",
        name: "_forwardTo",
        type: "address",
      },
    ],
    name: "getReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "getReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_poolId",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "invalidateReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isInit",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isShutdown",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "registeredRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardHook",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rewards",
    outputs: [
      {
        internalType: "address",
        name: "reward_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "reward_pool",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "reward_integral",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "reward_remaining",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "setApprovals",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_hook",
        type: "address",
      },
    ],
    name: "setHook",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "shutdown",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "totalBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "user_checkpoint",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdrawAndUnwrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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$bc773559428fe6419d41a765665bfcab46$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";

type ConvexStakingWrapperConstructorParams =
  | [
      linkLibraryAddresses: ConvexStakingWrapperLibraryAddresses,
      signer?: Signer
    ]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ConvexStakingWrapperConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class ConvexStakingWrapper__factory extends ContractFactory {
  constructor(...args: ConvexStakingWrapperConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(
        _abi,
        ConvexStakingWrapper__factory.linkBytecode(linkLibraryAddresses),
        signer
      );
    }
    this.contractName = "ConvexStakingWrapper";
  }

  static linkBytecode(
    linkLibraryAddresses: ConvexStakingWrapperLibraryAddresses
  ): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$bc773559428fe6419d41a765665bfcab46\\$__", "g"),
      linkLibraryAddresses[
        "contracts/external/convex/lib/CvxMining.sol:CvxMining"
      ]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ConvexStakingWrapper> {
    return super.deploy(overrides || {}) as Promise<ConvexStakingWrapper>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ConvexStakingWrapper {
    return super.attach(address) as ConvexStakingWrapper;
  }
  connect(signer: Signer): ConvexStakingWrapper__factory {
    return super.connect(signer) as ConvexStakingWrapper__factory;
  }
  static readonly contractName: "ConvexStakingWrapper";
  public readonly contractName: "ConvexStakingWrapper";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ConvexStakingWrapperInterface {
    return new utils.Interface(_abi) as ConvexStakingWrapperInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ConvexStakingWrapper {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ConvexStakingWrapper;
  }
}

export interface ConvexStakingWrapperLibraryAddresses {
  ["contracts/external/convex/lib/CvxMining.sol:CvxMining"]: string;
}
